import { SET_PRESERVATION_PROPORTIONS, SET_ACTIVE_SOCIAL_NETWORKS, SERVICE_SET_CROP_DIMENSIONS, SERVICE_SET_CROP_POSITION } from '../constants/serviceConstants';


export const serviceInitState = {
    isPreservationProportions: true,
    cropDimensions: { width: 0, height: 0 },
    cropPosition: { x: undefined, y: undefined },
    activeSocialNetwork: 'facebook'

};

const serviceReducer = (state: any, action: any) => {
    switch (action.type) {
        case SET_PRESERVATION_PROPORTIONS:
            return {
                ...state,
                isPreservationProportions: action.isPreservationProportions
            }
        case SERVICE_SET_CROP_DIMENSIONS:
            return {
                ...state,
                cropDimensions: action.cropDimensions
            }

        case SERVICE_SET_CROP_POSITION:
            return {
                ...state,
                cropPosition: action.cropPosition
            }
        case SET_ACTIVE_SOCIAL_NETWORKS:
            return {
                ...state,
                activeSocialNetwork: action.activeSocialNetwork
            }


        default:
            return { ...state };
    }
};

export default serviceReducer;